/* PW v94.5 PDP conversion blocks (snippets/pw-conv.liquid).
   1. Bundle selector: Buy 1 / 2 / 3 sets the existing quantity box, follows it back, and
      re-prices when the variant changes. Prices are the real variant price, 10% off for 2+.
   2. Delivery timeline: Ordered today, ships and arrives as business-day ranges counted from
      today, skipping weekends and the days USPS does not deliver. No countdowns. */
(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function bundle(box) {
    if (box.dataset.pwBound) return;
    box.dataset.pwBound = '1';
    var form = box.closest('form');
    var qty = form && form.querySelector('[data-pw-qty-input]');
    if (!qty) { box.hidden = true; return; }
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-pw-bnd-prices]').textContent) || {}; } catch (e) {}
    var radios = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"]'));
    var idInput = form.querySelector('[data-pw-variant-id]');

    function fromQty() {
      var n = parseInt(qty.value, 10) || 1;
      radios.forEach(function (r) { r.checked = parseInt(r.value, 10) === n; });
    }
    function reprice() {
      var p = idInput && prices[idInput.value];
      if (typeof p !== 'number') return;
      var set = function (sel, txt) { Array.prototype.forEach.call(box.querySelectorAll(sel), function (el) { el.textContent = txt; }); };
      set('[data-pw-bnd-now="1"]', money(p));
      set('[data-pw-bnd-now="2"]', money(Math.round(p * 2 * 0.9)));
      set('[data-pw-bnd-was="2"]', money(p * 2));
      set('[data-pw-bnd-now="3"]', money(Math.round(p * 3 * 0.9)));
      set('[data-pw-bnd-was="3"]', money(p * 3));
      set('[data-pw-bnd-each]', money(Math.round(p * 0.9)));
    }

    box.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      qty.value = e.target.value;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qty.addEventListener('input', fromQty);
    qty.addEventListener('change', fromQty);
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pw-qty]')) setTimeout(fromQty, 0);
    });
    var priceEl = document.querySelector('[data-pw-price]');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(function () { setTimeout(reprice, 0); }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
    fromQty();
    reprice();
  }

  /* US days with no USPS delivery, through 2027 */
  var OFF = { '2026-11-11': 1, '2026-11-26': 1, '2026-12-25': 1, '2027-01-01': 1, '2027-01-18': 1, '2027-02-15': 1, '2027-05-31': 1, '2027-06-18': 1, '2027-07-05': 1, '2027-09-06': 1, '2027-10-11': 1, '2027-11-11': 1, '2027-11-25': 1, '2027-12-24': 1, '2027-12-31': 1 };
  function key(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function addBiz(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && !OFF[key(d)]) n--;
    }
    return d;
  }
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var W = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function md(d) { return M[d.getMonth()] + ' ' + d.getDate(); }
  function range(a, b) {
    if (a.getTime() === b.getTime()) return md(a);
    return a.getMonth() === b.getMonth() ? md(a) + ' to ' + b.getDate() : md(a) + ' to ' + md(b);
  }

  function eta(el) {
    if (el.dataset.pwBound) return;
    el.dataset.pwBound = '1';
    var pl = parseInt(el.dataset.pLo, 10), ph = parseInt(el.dataset.pHi, 10);
    var tl = parseInt(el.dataset.tLo, 10), th = parseInt(el.dataset.tHi, 10);
    if (!(pl > 0 && ph >= pl && tl > 0 && th >= tl && ph + th < 60)) return;
    var now = new Date();
    now.setHours(12, 0, 0, 0);
    var s1 = addBiz(now, pl), s2 = addBiz(now, ph);
    var a1 = addBiz(s1, tl), a2 = addBiz(s2, th);
    var q = function (s) { return el.querySelector(s); };
    q('[data-pw-eta3-o]').textContent = 'Today, ' + md(now);
    q('[data-pw-eta3-s]').textContent = range(s1, s2);
    q('[data-pw-eta3-a]').textContent = range(a1, a2);
    q('[data-pw-eta3-date]').textContent = W[a2.getDay()] + ' ' + md(a2);
    q('[data-pw-eta3-by]').hidden = false;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pw-bnd]'), bundle);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pw-eta3]'), eta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
